// The signed-in sidebar's collapse button: folds the sidebar to an icon rail
// and opens it again, and remembers which in this browser.
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside protected_content.js, whose shape this is.
//
// The state is ONE attribute on <html>, `data-sidebar="collapsed"`, and
// components/_sidebar_rail.scss does the rest. This module is not what applies
// the stored state on load — layouts/auth_user's head script does that before
// <body> exists, so the rail never flashes open. This module's job on load is
// only to bring the button and the tooltips into line with whatever that
// script decided, and then to flip everything on click.
//
// Three things about it are easy to undo by accident:
//
// - THE KEY AND ITS VALUE ARE SHARED WITH THE HEAD SCRIPT. It reads "pq.sidebar"
//   and acts only on the exact string "collapsed"; anything else is the default
//   (open). Rename or add a value here and the layout stops agreeing with it.
// - `title` IS ADDED ONLY WHILE COLLAPSED. The server never emits it, and this
//   removes it when the rail opens, so a sighted reader of the open sidebar
//   never gets a tooltip repeating the word already beside the icon. The
//   label's text lives in data-sidebar-label, written by SidebarHelper.
// - localStorage is wrapped in try/catch on both sides. A private window
//   throws on ACCESS, and a student who cannot store a preference must still
//   get the toggle for this visit.

const KEY = "pq.sidebar";
const COLLAPSED = "collapsed";

function remember(collapsed) {
  try {
    window.localStorage.setItem(KEY, collapsed ? COLLAPSED : "expanded");
  } catch (e) {
    // Nothing to do and nothing to tell them: the rail still moved for this
    // visit, which is most of what they wanted.
  }
}

function apply(button, collapsed) {
  const root = document.documentElement;
  if (collapsed) {
    root.setAttribute("data-sidebar", COLLAPSED);
  } else {
    root.removeAttribute("data-sidebar");
  }

  button.setAttribute("aria-expanded", String(!collapsed));
  button.setAttribute("aria-label", collapsed ? "Expand navigation" : "Collapse navigation");
  const icon = button.querySelector("i");
  if (icon) {
    icon.classList.toggle("fa-angles-left", !collapsed);
    icon.classList.toggle("fa-angles-right", collapsed);
  }

  document.querySelectorAll("[data-sidebar-label]").forEach((el) => {
    if (collapsed) {
      el.setAttribute("title", el.dataset.sidebarLabel);
    } else {
      el.removeAttribute("title");
    }
  });
}

function setup() {
  const button = document.querySelector("[data-sidebar-toggle]");
  if (!button) return;

  // The head script has already spoken; agree with it.
  let collapsed = document.documentElement.getAttribute("data-sidebar") === COLLAPSED;
  apply(button, collapsed);

  button.addEventListener("click", () => {
    collapsed = !collapsed;
    apply(button, collapsed);
    remember(collapsed);
  });
}

// The same guard every module in this pack carries — see mock_request_wizard.js.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
